export default __webpack_public_path__ + "static/media/intrvl_name_logo.81e9c02a.svg";